import { Accordion } from "flowbite-react"

const OdooFAQ: React.FC = () => {
  return (
    <>
      <Accordion>
        <Accordion.Panel>
          <Accordion.Title as="h3" className="accordion-title">
            What do the Success Packs include?
          </Accordion.Title>
          <Accordion.Content className="accordion-border">
            <div className="fs-md mb-0 text-secondary">
              The Success Packs include a package of premium services by a
              dedicated consultant. During the implementation phase, you will
              have an Odoo Project Manager assigned to you to analyze your
              requirements and configure your Odoo Apps according to your needs.
              The consultant will also train you on how to use the Odoo Apps,
              coach you on how you can use Odoo&apos;s functions and features to
              grow your business. He will also customize your Odoo apps provided
              that you opted for the &apos;Custom apps&apos; you have selected.
              Based on the apps and number of custom apps you selected on the
              pricing page, a pack will be preselected that best fits the
              typical number of hours needed to start using Odoo successfully.
              Our consultants will do their best efforts to help you get started
              with Odoo within that time.
            </div>
          </Accordion.Content>
        </Accordion.Panel>
        <Accordion.Panel>
          <Accordion.Title as="h3" className="accordion-title">
            What will the &apos;Dedicated Customer Success Consultant&apos; do ?
          </Accordion.Title>
          <Accordion.Content className="accordion-border">
            <div className="fs-md mb-0 text-secondary">
              A Dedicated Customer Success Consultant ensures you maximize the
              value of Odoo ERP solutions. They work closely with you to ensure
              customer satisfaction and long-term success by offering tailored
              guidance and support, addressing your specific business needs, and
              helping you leverage Odoo&apos;s capabilities to their fullest
              potential.
            </div>
          </Accordion.Content>
        </Accordion.Panel>
        <Accordion.Panel>
          <Accordion.Title as="h3" className="accordion-title">
            What if I have custom needs that require developments and ad hoc
            integration?
          </Accordion.Title>
          <Accordion.Content className="accordion-border">
            <div className="fs-md mb-0 text-secondary">
              For custom requirements involving developments and ad hoc
              integration, your Dedicated Customer Success Consultant will
              collaborate with you to understand these needs thoroughly. They
              will ensure that your specific requirements are addressed
              effectively, providing tailored Odoo ERP development solutions and
              seamless integration with your existing systems.
            </div>
          </Accordion.Content>
        </Accordion.Panel>
        <Accordion.Panel>
          <Accordion.Title as="h3" className="accordion-title">
            What should I do if I have performance issues?
          </Accordion.Title>
          <Accordion.Content className="accordion-border">
            <div className="fs-md mb-0 text-secondary">
              If you encounter performance issues with your Odoo system, several
              steps can be taken to address the situation. Contact our support
              team for prompt assistance. Our experts will analyze the issue,
              offer troubleshooting guidance, and provide solutions to restore
              optimal performance.
            </div>
          </Accordion.Content>
        </Accordion.Panel>
        <Accordion.Panel>
          <Accordion.Title as="h3" className="accordion-title">
            How much will it cost for a Odoo development project?
          </Accordion.Title>
          <Accordion.Content className="accordion-border">
            <div className="fs-md mb-0 text-secondary">
              The cost of an Odoo development project varies based on several
              factors, including the complexity of the app, technical expertise
              required, experience of the developers, features to be integrated,
              total development hours, and more. To receive an accurate project
              quote, please share your specific project requirements with us,
              and our team will provide a detailed estimate.
            </div>
          </Accordion.Content>
        </Accordion.Panel>
      </Accordion>
    </>
  )
}

export default OdooFAQ
